import React, { useEffect, useRef, useState } from 'react';

export const RESERVATION_TYPE_OPTIONS = [
  { value: 'flash', label: 'FLASH' },
  { value: 'personal_project', label: 'PERSONAL' },
  { value: 'other', label: 'OTHER' },
  { value: 'retouch', label: 'RETOUCH' }
];

const SELECTED_RESERVATION_TYPE_COLOR = '#16a34a';
const RESERVATION_TYPE_GRID_GAP = 4;
const RESERVATION_TYPE_MIN_BUTTON_WIDTH = 76;

export const getReservationTypeLabel = (value) => {
  return RESERVATION_TYPE_OPTIONS.find(option => option.value === value)?.label || value || '-';
};

export default function ReservationTypeSelector({
  value,
  onChange,
  disabled = false,
  style = {},
  buttonStyle = {}
}) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const useCompactGrid = containerWidth > 0
    && containerWidth < RESERVATION_TYPE_MIN_BUTTON_WIDTH * RESERVATION_TYPE_OPTIONS.length
    + RESERVATION_TYPE_GRID_GAP * (RESERVATION_TYPE_OPTIONS.length - 1);

  useEffect(() => {
    if (!containerRef.current || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(([entry]) => {
      setContainerWidth(entry.contentRect.width);
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      role="radiogroup"
      aria-label="Reservation type"
      style={{
        display: 'grid',
        gridTemplateColumns: useCompactGrid ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
        gap: `${RESERVATION_TYPE_GRID_GAP}px`,
        flex: 1,
        minWidth: 0,
        width: '100%',
        ...style
      }}
    >
      {RESERVATION_TYPE_OPTIONS.map(option => {
        const isSelected = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            disabled={disabled}
            onClick={() => onChange?.(option.value)}
            style={{
              minWidth: 0,
              minHeight: '24px',
              padding: '3px 4px',
              border: isSelected ? `1px solid ${SELECTED_RESERVATION_TYPE_COLOR}` : '1px solid #d7d7d7',
              borderRadius: '4px',
              backgroundColor: '#fff',
              color: isSelected ? SELECTED_RESERVATION_TYPE_COLOR : '#333',
              fontSize: '11px',
              fontWeight: 500,
              lineHeight: 1.1,
              letterSpacing: 0,
              whiteSpace: 'nowrap',
              wordBreak: 'keep-all',
              overflowWrap: 'normal',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.55 : 1,
              textAlign: 'center',
              transition: 'background-color 120ms ease, color 120ms ease, border-color 120ms ease',
              ...buttonStyle
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
